import { ref } from "vue";
import { BlockUI } from "@/helpers/blockUI";

export function useBlockUI(target?: HTMLElement | string) {
  const isBlocked = ref(false);
  let blockUIInstance: BlockUI | null = null;

  const block = (options?: string | { message?: string; spinner?: boolean }) => {
    if (!blockUIInstance) {
      blockUIInstance = new BlockUI(target);
    }
    blockUIInstance.block(options);
    isBlocked.value = true;
  };

  const unblock = () => {
    if (blockUIInstance) {
      blockUIInstance.unblock();
      isBlocked.value = false;
    }
  };

  const toggle = (message?: string) => {
    if (isBlocked.value) {
      unblock();
    } else {
      block(message);
    }
  };

  return {
    isBlocked,
    blockUI: block,
    unblockUI: unblock,
    toggleBlockUI: toggle,
  };
}
